export default function (count: Number, word: String, plural = `${word}s`) {
  return `${count} ${count === 1 ? word : plural}`
}
